// BrandMark — the Release Hub logo (the "Timeline spine" favicon, variant B):
// an amber tile with a cream feed spine and the newest entry highlighted.
// Self-contained (colors baked in), so it reads the same on any background.
// Size it with a `className` (e.g. `h-6 w-6`); the viewBox scales to fit.
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={className}
      role="img"
      aria-label="Release Hub"
    >
      <rect width="32" height="32" rx="7" fill="#b45309" />
      <line
        x1="11.5"
        y1="7.5"
        x2="11.5"
        y2="24.5"
        stroke="#f3d9b8"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <line
        x1="16.5"
        y1="11.5"
        x2="25"
        y2="11.5"
        stroke="#faf7f2"
        strokeWidth="1.9"
        strokeLinecap="round"
      />
      <line
        x1="16.5"
        y1="20.5"
        x2="22.5"
        y2="20.5"
        stroke="#f0d6b6"
        strokeWidth="1.9"
        strokeLinecap="round"
      />
      <circle cx="11.5" cy="11.5" r="3.2" fill="#ffffff" />
      <circle cx="11.5" cy="20.5" r="3.2" fill="#eec79a" />
    </svg>
  );
}
